import useAxiosInterceptor from 'src/services/interceptor';
import { dashboardApiCall } from '../constants';
class DashboardServices {
  private axiosInstance;

  constructor() {
    this.axiosInstance = useAxiosInterceptor();
  }

  getDashboardPatientList = (payload: any) => {
    return this.axiosInstance.get(`${dashboardApiCall.patientv2List}`, {
      params: {
        ...payload,
        searchString: payload?.searchString,
        pageSize: 100,
        forDashboard: true,
      },
    });
  };

  getDashboardOverView = (payload: any) => {
    return this.axiosInstance.get(`${dashboardApiCall.taskOverview}`, { params: payload });
  };
  getDashboardTherapyOverView = (payload: any) => {
    return this.axiosInstance.get(`${dashboardApiCall.therapySession}`, { params: payload });
  };
  getDashboardDocumentationOverView = (payload: any) => {
    return this.axiosInstance.get(`${dashboardApiCall.documentationTask}`, { params: payload });
  };

  getTimeCheckIn = (payload: any) => {
    const { providerId, ...restPayload } = payload;
    return this.axiosInstance.get(`${dashboardApiCall.timeCheckIn}/${providerId}`, {
      params: restPayload,
    });
  };

  postTimeCheckout = (payload: any) => {
    const { providerId, isLogout, clockInBody, idleTimeExpired, ...restPayload } = payload;
    return this.axiosInstance.put(`${dashboardApiCall.timeCheckout}/${providerId}`, clockInBody, {
      params: restPayload,
    });
  };

  getDashboardDocument = (payload: any) => {
    return this.axiosInstance.post(dashboardApiCall.dashboardDocuments, payload?.param);
  };
  getDashboardCsvDocument = (payload: any) => {
    return this.axiosInstance.post(dashboardApiCall.dashboardDocuments, payload?.param);
  };

  getPatientDetails = (payload: any) => {
    const { patientId, ...restPayload } = payload;
    return this.axiosInstance.get(`${dashboardApiCall.patientDetails}/${patientId}/therapy-info`, {
      params: restPayload,
    });
  };
  getLatestPtoUpdate = (payload: any) => {
    return this.axiosInstance.get(`${dashboardApiCall.ptoUpdates}/${payload?.providerId}`);
  };

  getInterventionGroup = (payload: any) => {
    return this.axiosInstance.get(`${dashboardApiCall.interventionGroup}`, {
      params: payload?.params,
    });
  };

  getGameByIntervention = (payload: any) => {
    return this.axiosInstance.get(
      `${dashboardApiCall.gamesByIntervention}/${payload?.interventionId}`
    );
  };
  getAutoClockOutCall = (payload: any) => {
    return this.axiosInstance.put(`${dashboardApiCall.autoClockOut}`, null, {
      params: payload,
    });
  };

  getTherapistDailyUpdates = (payload: any) => {
    return this.axiosInstance.get(
      `${dashboardApiCall.therapistDailyUpdates}/${payload?.providerId}?date=${payload?.currentDate}`,
      {
        params: payload?.params,
      }
    );
  };
}

const dashboardServices = new DashboardServices();

Object.freeze(dashboardServices);

export default dashboardServices;
